export default "__VITE_ASSET__9b786596__"